import type { InactiveMemberDto } from "@/modules/boxDashboard/gateway/boxDashboardApiDto"
import dayjs from "dayjs"

export const INACTIVE_MEMBER_DEFAULT: InactiveMemberDto = {
  boxMemberItemDto: {
    id: "member-1",
    firstname: "John",
    lastname: "Doe",
    status: "ACTIVE",
    avatar: null,
    username: "johndoe",
    note: null,
    lastVisited: null,
    noShowPastMonth: null,
    activeOffers: [],
    archivedDate: null,
    inscriptionDate: dayjs().subtract(6, "months").toISOString(),
    archived: false,
    lastMembership: null,
  },
  numberOfDays: 32,
  purchaseName: "Session Pack",
  lastSlot: {
    id: "slot-1",
    startTime: dayjs().subtract(32, "days").toISOString(),
    endTime: dayjs().subtract(32, "days").add(1, "hour").toISOString(),
    programId: "program-1",
    registeredParticipantCount: 1,
    pendingParticipantCount: 0,
    participantLimit: 10,
    sessionId: "session-1",
    location: null,
    isFromTemplate: false,
    participation: null,
    allowMultiBooking: false,
    dropinsAccepted: true,
    trialsAccepted: true,
    assignedStaffMembers: [],
  },
  lastDate: dayjs().subtract(32, "days").toISOString(),
}

export const INACTIVE_MEMBERS_LIST: InactiveMemberDto[] = [
  INACTIVE_MEMBER_DEFAULT,
  {
    boxMemberItemDto: {
      id: "member-2",
      firstname: "Sarah",
      lastname: "Johnson",
      status: "ACTIVE",
      avatar: null,
      username: "sarahjohnson",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(8, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 45,
    purchaseName: "Monthly Unlimited",
    lastSlot: {
      id: "slot-2",
      startTime: dayjs().subtract(45, "days").toISOString(),
      endTime: dayjs().subtract(45, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-2",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(45, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-3",
      firstname: "Mike",
      lastname: "Williams",
      status: "ACTIVE",
      avatar: null,
      username: "mikewilliams",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(1, "year").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 60,
    purchaseName: "Annual Membership",
    lastSlot: {
      id: "slot-3",
      startTime: dayjs().subtract(60, "days").toISOString(),
      endTime: dayjs().subtract(60, "days").add(1, "hour").toISOString(),
      programId: "program-2",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-3",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(60, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-4",
      firstname: "Emma",
      lastname: "Brown",
      status: "ACTIVE",
      avatar: null,
      username: "emmabrown",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(4, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 35,
    purchaseName: "10 Session Pack",
    lastSlot: {
      id: "slot-4",
      startTime: dayjs().subtract(35, "days").toISOString(),
      endTime: dayjs().subtract(35, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-4",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(35, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-5",
      firstname: "David",
      lastname: "Garcia",
      status: "ACTIVE",
      avatar: null,
      username: "davidgarcia",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(10, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 90,
    purchaseName: "Annual Membership",
    lastSlot: {
      id: "slot-5",
      startTime: dayjs().subtract(90, "days").toISOString(),
      endTime: dayjs().subtract(90, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-5",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(90, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-6",
      firstname: "Lisa",
      lastname: "Martinez",
      status: "ACTIVE",
      avatar: null,
      username: "lisamartinez",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(5, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 42,
    purchaseName: "Drop-in",
    lastSlot: {
      id: "slot-6",
      startTime: dayjs().subtract(42, "days").toISOString(),
      endTime: dayjs().subtract(42, "days").add(1, "hour").toISOString(),
      programId: "program-2",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-6",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(42, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-7",
      firstname: "James",
      lastname: "Anderson",
      status: "ACTIVE",
      avatar: null,
      username: "jamesanderson",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(3, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 31,
    purchaseName: "5 Session Pack",
    lastSlot: {
      id: "slot-7",
      startTime: dayjs().subtract(31, "days").toISOString(),
      endTime: dayjs().subtract(31, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-7",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(31, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-8",
      firstname: "Jennifer",
      lastname: "Taylor",
      status: "ACTIVE",
      avatar: null,
      username: "jennifertaylor",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(7, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 55,
    purchaseName: "Monthly Unlimited",
    lastSlot: {
      id: "slot-8",
      startTime: dayjs().subtract(55, "days").toISOString(),
      endTime: dayjs().subtract(55, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-8",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(55, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-9",
      firstname: "Robert",
      lastname: "Wilson",
      status: "ACTIVE",
      avatar: null,
      username: "robertwilson",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(9, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 38,
    purchaseName: "Quarterly Pass",
    lastSlot: {
      id: "slot-9",
      startTime: dayjs().subtract(38, "days").toISOString(),
      endTime: dayjs().subtract(38, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-9",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(38, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-10",
      firstname: "Patricia",
      lastname: "Moore",
      status: "ACTIVE",
      avatar: null,
      username: "patriciamoore",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(11, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 72,
    purchaseName: "Annual Membership",
    lastSlot: {
      id: "slot-10",
      startTime: dayjs().subtract(72, "days").toISOString(),
      endTime: dayjs().subtract(72, "days").add(1, "hour").toISOString(),
      programId: "program-2",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-10",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(72, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-11",
      firstname: "Michael",
      lastname: "Jackson",
      status: "ACTIVE",
      avatar: null,
      username: "michaeljackson",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(2, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 33,
    purchaseName: "Trial Session",
    lastSlot: {
      id: "slot-11",
      startTime: dayjs().subtract(33, "days").toISOString(),
      endTime: dayjs().subtract(33, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-11",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(120, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-12",
      firstname: "Linda",
      lastname: "White",
      status: "ACTIVE",
      avatar: null,
      username: "lindawhite",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(14, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 120,
    purchaseName: "Annual Membership",
    lastSlot: {
      id: "slot-12",
      startTime: dayjs().subtract(120, "days").toISOString(),
      endTime: dayjs().subtract(120, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-12",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(120, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-13",
      firstname: "William",
      lastname: "Harris",
      status: "ACTIVE",
      avatar: null,
      username: "williamharris",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(6, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 48,
    purchaseName: "20 Session Pack",
    lastSlot: {
      id: "slot-13",
      startTime: dayjs().subtract(48, "days").toISOString(),
      endTime: dayjs().subtract(48, "days").add(1, "hour").toISOString(),
      programId: "program-2",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-13",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(65, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-14",
      firstname: "Elizabeth",
      lastname: "Clark",
      status: "ACTIVE",
      avatar: null,
      username: "elizabethclark",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(8, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 65,
    purchaseName: "Monthly Unlimited",
    lastSlot: {
      id: "slot-14",
      startTime: dayjs().subtract(65, "days").toISOString(),
      endTime: dayjs().subtract(65, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-14",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(65, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-15",
      firstname: "Christopher",
      lastname: "Lewis",
      status: "ACTIVE",
      avatar: null,
      username: "christopherlewis",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(4, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 40,
    purchaseName: "10 Session Pack",
    lastSlot: {
      id: "slot-15",
      startTime: dayjs().subtract(40, "days").toISOString(),
      endTime: dayjs().subtract(40, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-15",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(40, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-16",
      firstname: "Susan",
      lastname: "Walker",
      status: "ACTIVE",
      avatar: null,
      username: "susanwalker",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(12, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 85,
    purchaseName: "Annual Membership",
    lastSlot: {
      id: "slot-16",
      startTime: dayjs().subtract(85, "days").toISOString(),
      endTime: dayjs().subtract(85, "days").add(1, "hour").toISOString(),
      programId: "program-2",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-16",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(85, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-17",
      firstname: "Daniel",
      lastname: "Hall",
      status: "ACTIVE",
      avatar: null,
      username: "danielhall",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(5, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 36,
    purchaseName: "Drop-in",
    lastSlot: {
      id: "slot-17",
      startTime: dayjs().subtract(36, "days").toISOString(),
      endTime: dayjs().subtract(36, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-17",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(36, "days").toISOString(),
  },
  {
    boxMemberItemDto: {
      id: "member-18",
      firstname: "Nancy",
      lastname: "Allen",
      status: "ACTIVE",
      avatar: null,
      username: "nancyallen",
      note: null,
      lastVisited: null,
      noShowPastMonth: null,
      activeOffers: [],
      archivedDate: null,
      inscriptionDate: dayjs().subtract(7, "months").toISOString(),
      archived: false,
      lastMembership: null,
    },
    numberOfDays: 52,
    purchaseName: "Monthly Unlimited",
    lastSlot: {
      id: "slot-18",
      startTime: dayjs().subtract(52, "days").toISOString(),
      endTime: dayjs().subtract(52, "days").add(1, "hour").toISOString(),
      programId: "program-1",
      registeredParticipantCount: 1,
      pendingParticipantCount: 0,
      participantLimit: 10,
      sessionId: "session-18",
      location: null,
      isFromTemplate: false,
      participation: null,
      allowMultiBooking: false,
      dropinsAccepted: true,
      trialsAccepted: true,
      assignedStaffMembers: [],
    },
    lastDate: dayjs().subtract(52, "days").toISOString(),
  },
]
